import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Ordine, STATO_ORDINE, TIPO_ORDINE_API} from "../../../../../../models/Ordine";
import {ServerService} from "../../../../../../services/server.service";
import {OrdineSlave} from "../../../../../../models/OrdineSlave";
import {GuiService} from "../../../../../../services/gui.service";
import {
   InfoTrasferimentoComponent
} from "../../pv-trasferimenti/pv-nuovo-trasferimento/info-trasferimento/info-trasferimento.component";
import {DialogService} from "../../../../../../components/generics/dialog/dialog.service";
import {ComposizioneRettificaComponent} from "../general/composizione-rettifica/composizione-rettifica.component";
import {OrdineService} from "../../../../../../services/ordine.service";
import {Subscription} from "rxjs";

@Component({
   selector: 'app-rettifica',
   templateUrl: './rettifica.component.html',
   styleUrls: ['./rettifica.component.scss']
})
export class RettificaComponent implements OnInit, AfterViewInit, OnDestroy {
   @ViewChild('infoRettificaComponent') infoComponent!:InfoTrasferimentoComponent;
   @ViewChild('composizioneRettificaComponent') composizioneComponent!:ComposizioneRettificaComponent;

   @ViewChild('headerTopComponent') headerTopComponent;

   public ordine: Ordine = new Ordine({})
   public ordiniSlave: OrdineSlave[] = []

   breadcrumbs: any[] = []
   public selectedIndex;

   public vendorSlug;
   public pVenditaId;
   public ordineId;

   public tipoRettifica

   public labelRettifica
   public labelRettificaPlurale

   STATO_ORDINE = STATO_ORDINE;
   private valueSubscription: Subscription;

   constructor(private router: Router,
               private route: ActivatedRoute,
               private serverSrv: ServerService,
               private guiSrv: GuiService,
               private dialogSrv: DialogService,
               private ordineSrv: OrdineService
   ) {
      this.ordineSrv.component = this
      this.tipoRettifica = this.route.parent?.snapshot.url[0].path
      this.labelRettifica = this.tipoRettifica == TIPO_RETTIFICA.AMMANCHI ? 'ammanco' : 'esubero'
      this.labelRettificaPlurale = this.tipoRettifica == TIPO_RETTIFICA.AMMANCHI ? 'ammanchi' : 'esuberi'


      this.breadcrumbs = this.breadcrumbs = [
         {text:`Lista ${this.labelRettificaPlurale}`, onClick: () => {
               this.router.navigate(['../'], {relativeTo:this.route})
            }},
         {text:`Informazioni sull'${this.labelRettifica}`, active:true, onClick: () => {
               this.selectedIndex = 0
            }},
         {text:`Composizione ${this.labelRettifica}`, onClick: () => {
               this.infoComponent.infoOrdineFrm.markAllAsTouched()
               if (this.infoComponent.infoOrdineFrm.valid || this.ordine.data.stato != STATO_ORDINE.BOZZA){
                  this.selectedIndex = 1
                  if (this.ordine.data.stato == STATO_ORDINE.BOZZA) this.saveOrder(true)
               }
               else this.dialogSrv.showToastError({title:"Compila i dati", err:"Compila tutti i dati prima di proseguire"})
            }},
         {text:`Riepilogo ${this.labelRettifica}`, onClick: () => {
               this.selectedIndex = 2
               if (this.ordine.data.stato == STATO_ORDINE.BOZZA) this.saveOrder(true)
            }},
      ]

      this.route.pathFromRoot[3].params.subscribe(res => {
         this.vendorSlug = res.esercizio_slug
      })
      this.pVenditaId = this.route.parent?.parent?.parent?.snapshot.paramMap.get('pvendita_id')
      this.ordineId = this.route.snapshot.paramMap.get('ordine_id')

      this.valueSubscription = this.ordineSrv.getValue$().subscribe((value) => {
         // Qui puoi gestire l'evento onchange con il valore ricevuto dal service
         if (value['ordiniSlave']) this.ordiniSlave = value['ordiniSlave']
         if (value['ordine']) this.ordine = value['ordine']
      });

   }

   ngOnInit(): void {
   }

   ngAfterViewInit(): void {
      this.fetchOrdine()
      this.fetchOrdiniSlave()
   }

   ngOnDestroy(): void {
      this.valueSubscription.unsubscribe();
   }

   fetchOrdine(){
      this.ordineSrv.fetchOrdine(TIPO_ORDINE_API.RETTIFICA, this.ordineId).then(res => {
         this.ordine = res
      })
   }

   fetchOrdiniSlave(){
      this.ordineSrv.fetchOrdiniSlave(this.vendorSlug, this.pVenditaId, this.ordineId).then(res => {
         this.ordiniSlave = res
      })
   }

   setBreadcrumb(i: any) {
      console.log(i)
      this.breadcrumbs[i].active = true
      this.headerTopComponent.clickBreadcrumb(this.breadcrumbs[i])
   }

   async saveOrder(isBozza, saveExit=false) {
      this.ordineSrv.saveOrder(isBozza, saveExit, false, TIPO_ORDINE_API.RETTIFICA, this.infoComponent,
         this.composizioneComponent, null, null, `?tipo=${this.tipoRettifica}`)
   }
}

export enum TIPO_RETTIFICA{
   AMMANCHI = "ammanchi",
   ESUBERI = "esuberi"
}
